<template>

  <div id="footer">
    <router-link to="/home">
      <span>
      <!-- <i class='fa fa-user' aria-hidden='true'></i> -->
      <img src="../../assets/images/home-icon-on.png" alt="아이콘 이미지1">
      </span>홈
    </router-link>
    
    <a href="#">
      <span>
      <!-- <i class='fa fa-user' aria-hidden='true'></i> -->
      <img src="../../assets/images/book-icon-on.png" alt="아이콘 이미지2">
      </span>찜하기
    </a>
    <a href="#">
      <span>
      <!-- <i class='fa fa-user' aria-hidden='true'></i> -->
      <img src="../../assets/images/search-icon-on.png" alt="아이콘 이미지3">
      </span>검색
    </a>
    <a href="#">
      <span>
      <!-- <i class='fa fa-user' aria-hidden='true'></i> -->
      <img src="../../assets/images/user-icon-on.png" alt="아이콘 이미지4">
      </span>프로필
    </a>
  </div>

</template>

<script>

export default {
  name: 'Footer',
  mounted(){
    this.mainMenu();
  },
  methods: {
    mainMenu(){
      $(function(){
    // Footer Setting
    $('#footer a:nth-child(1)').hover(
      function(){
        $(this).css('color','#fc0').find('img').attr('src','./src/assets/images/home-icon-off.png')
      },
      function(){
        $(this).css('color','#fff').find('img').attr('src','./src/assets/images/home-icon-on.png')
      }
    );
    $('#footer a:nth-child(2)').hover(
      function(){
        $(this).css('color','#fc0').find('img').attr('src','./src/assets/images/book-icon-off.png')
      },
      function(){
        $(this).css('color','#fff').find('img').attr('src','./src/assets/images/book-icon-on.png')
      }
    );
    $('#footer a:nth-child(3)').hover(
      function(){
        $(this).css('color','#fc0').find('img').attr('src','./src/assets/images/search-icon-off.png')
      },
      function(){
        $(this).css('color','#fff').find('img').attr('src','./src/assets/images/search-icon-on.png')
      }
    );
    $('#footer a:nth-child(4)').hover(
      function(){
        $(this).css('color','#fc0').find('img').attr('src','./src/assets/images/user-icon-off.png')
      },
      function(){
        $(this).css('color','#fff').find('img').attr('src','./src/assets/images/user-icon-on.png')
      }
    );
      
      
    });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../sass/partials/mixin", "../../sass/partials/variable";

  #footer{
    width: 100%;
    height: 90px;
    background-color: rgba(43,43,43, 0.8);
    position: fixed; left: 0;bottom: 0;
    z-index: 30;
    a{
      width: 25%;
      height: 100%;
      float:left;
      color : $color3;
      text-align: center;
      padding-top: 21px;
      @include font-set(500, 1.6rem, 1.5, $ff1);


     span{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 36px;
      img{
        height: 30px;

      }
    }
    }
  }


</style>


// WEBPACK FOOTER //
// src/components/component/Footer.vue